import React from 'react'
import gsap from "gsap";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import './ourValues.css'

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

const OurValues = (props) => {
    // console.log('props', props)
    const two = useRef(null);
    const ourValues = useRef(null);

    useGSAP(() => {
        const pTags = two.current.querySelectorAll("p");
        gsap.from(pTags, {
            scale: 1.2,
            opacity: 0,
            stagger: 1,
            duration: 1.9,
            ease: "elastic.out",
        });
    });

    useGSAP(() => {
        gsap.from(ourValues.current, {
            opacity: 0,
            stagger: 0.1,
            delay: 0.2,
            duration: 10,
            ease: "elastic.out",
        });
    });

    return (
        <div>
            <div className="container ourValuesContainer">
                <div className="section">
                    <div ref={two}>
                        <p className='ourValuesText'>Our values</p>
                        <h1 ref={ourValues} className='ourValues'>We love cars, and we know you do too. At Bandara Motoren, we believe every car has a soul, and our mission is to create digital clusters that complement their unique aesthetic and spirit.</h1>
                        {/* <p>soon...</p> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurValues